import React, { memo, useEffect, useState, useCallback } from "react";
import { Chip, Tooltip } from "@mui/material";
import {
  QuestionAnswer,
  Code as VariablesIcon,
  Save as SaveIcon
} from "@mui/icons-material";

import { NodeHead, NodeHandle, useNodeStyles } from "./nodeKit";
import { processVariablesInText } from "../../../utils/variableUtils";

export default memo(({ data, isConnectable, id }) => {
  const classes = useNodeStyles();
  const [processedQuestion, setProcessedQuestion] = useState(data.question || "");
  const [variableValue, setVariableValue] = useState("");
  const [isExecutionMode, setIsExecutionMode] = useState(false);
 
  const extractVariables = (text) => {
    if (!text) return [];
    const regex = /\$\{([^}]+)\}/g;
    const matches = [];
    let match;
    
    while ((match = regex.exec(text)) !== null) {
      matches.push(match[1]);
    }
    
    return [...new Set(matches)];
  };

  const updateProcessedQuestion = useCallback(() => {
    const originalText = data.question || "";
    const newText = processVariablesInText(originalText);
    setProcessedQuestion(newText);
  }, [data.question]);
  

  useEffect(() => {
    const isExecutionPath = !window.location.pathname.includes('/flowbuilder-config');
    setIsExecutionMode(isExecutionPath);
    
 
    if (isExecutionPath && data.variableName) {
      const checkVariableValue = () => {
        if (window.flowVariables && window.flowVariables[data.variableName]) {
          setVariableValue(window.flowVariables[data.variableName]);
        }
      };
    
      checkVariableValue();
      
      const intervalId = setInterval(checkVariableValue, 1000);
      
      return () => clearInterval(intervalId);
    }
  }, [data.variableName]);

  useEffect(() => {
    updateProcessedQuestion();

    const handleVariableUpdate = () => {
      console.log('[inputNode] Detectada atualização de variáveis');
      updateProcessedQuestion();
    };
 
    window.addEventListener('flowVariableUpdate', handleVariableUpdate);
    
    const intervalId = setInterval(() => {
      updateProcessedQuestion();
    }, 500);
    

    return () => {
      window.removeEventListener('flowVariableUpdate', handleVariableUpdate);
      clearInterval(intervalId);
    };
  }, [data.question, updateProcessedQuestion]);

  const chipSx = { height: 20, fontSize: 11.5, my: 0.25, mx: 0.5, "& .MuiChip-label": { px: 1 } };

  return (
    <div className={`${classes.root} kp-flow-node`} style={{ width: 280 }}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      <NodeHead color="#9c27b0" icon={<QuestionAnswer />} title="Input" id={id} />

      <div className={classes.body}>
        <div className={classes.slot} style={{ minHeight: 52, maxHeight: 150, overflow: "auto" }}>
          <div className={classes.hint} style={{ marginTop: 0, marginBottom: 4 }}>Pergunta</div>
          {data.question ? (
            <div style={{ fontWeight: 400, wordBreak: "break-word" }}>
              {!isExecutionMode ? (
                data.question.split(/\$\{([^}]+)\}/).map((part, index) => {
                  if (index % 2 === 0) {
                    return <span key={index}>{part}</span>;
                  }
                  return <Chip key={index} label={part} size="small" sx={chipSx} />;
                })
              ) : (
                processedQuestion
              )}
            </div>
          ) : (
            <div className={classes.hint} style={{ marginTop: 0, fontStyle: "italic" }}>
              Pergunta não definida
            </div>
          )}
        </div>

        <div className={classes.slot}>
          <div className={classes.hint} style={{ marginTop: 0, marginBottom: 4 }}>
            Variável para armazenar resposta
          </div>
          {data.variableName ? (
            <div className={classes.slotRow}>
              <Chip label={data.variableName} size="small" sx={{ ...chipSx, mx: 0, height: 22 }} />
              {isExecutionMode && variableValue && (
                <Tooltip title={`Valor: ${variableValue}`}>
                  <span className={classes.slotRow} style={{ fontSize: 11.5, fontWeight: 400 }}>
                    <SaveIcon />
                    {variableValue.length > 15 ? `${variableValue.substring(0, 15)}...` : variableValue}
                  </span>
                </Tooltip>
              )}
            </div>
          ) : (
            <div className={classes.hint} style={{ marginTop: 0, fontStyle: "italic" }}>
              Variável não definida
            </div>
          )}
        </div>

        {data.question && data.question.includes("${") && (
          <div className={`${classes.hint} ${classes.slotRow}`}>
            <VariablesIcon />
            <span>Usando variáveis: {extractVariables(data.question).join(", ")}</span>
          </div>
        )}
      </div>

      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </div>
  );
});
